// ConfirmationModal.jsx
import React from 'react';

function ConfirmationModal({ show, onConfirm, onCancel, message, title }) {
    if (!show) return null;

    return (
        <>
            {/* Backdrop */}
            <div 
                className="modal-backdrop"
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    zIndex: 1055,
                }}
            />

            {/* Confirmation Modal */}
            <div 
                style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 1060,
                    backgroundColor: 'white',
                    borderRadius: '8px',
                    boxShadow: '0 5px 15px rgba(0, 0, 0, 0.3)',
                    minWidth: '400px',
                    maxWidth: '500px'
                }}
            >
                {/* Header */}
                <div style={{
                    padding: '15px 20px',
                    borderBottom: '1px solid #dee2e6',
                    display: 'flex',
                    alignItems: 'center'
                }}>
                    <i className="bi bi-exclamation-triangle-fill text-warning" 
                       style={{ fontSize: '24px', marginRight: '10px' }}></i>
                    <h5 style={{ margin: 0, fontWeight: '600' }}>
                        {title || 'Confirmation'}
                    </h5>
                </div>

                {/* Body */}
                <div style={{ padding: '20px', fontSize: '16px' }}>
                    {message}
                </div>

                {/* Footer */}
                <div style={{
                    padding: '15px 20px',
                    borderTop: '1px solid #dee2e6',
                    display: 'flex',
                    justifyContent: 'flex-end',
                    gap: '10px'
                }}>
                    <button 
                        onClick={onConfirm}
                        className="btn btn-primary"
                        style={{ minWidth: '80px' }}
                    >
                        <i className="bi bi-check-circle"></i> Yes
                    </button>
                    <button 
                        onClick={onCancel}
                        className="btn btn-secondary"
                        style={{ minWidth: '80px' }}
                    >
                        <i className="bi bi-x-circle"></i> Cancel
                    </button>
                    
                </div>
            </div>
        </>
    );
}

export default ConfirmationModal;